/** @format */

import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

const Contact = () => {
  const [isSending, setIsSending] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);

    const formData = new FormData(e.target);

    try {
      const response = await fetch("https://formspree.io/f/xyzgrbpv", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      });

      if (response.ok) {
        setToastMessage("Message sent successfully!");
        e.target.reset();
      } else {
        setToastMessage("Error sending message. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      setToastMessage("Error sending message. Please try again.");
    } finally {
      setIsSending(false);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };

  return (
    <article className="contact active" data-page="contact">
      <header>
        <h2 className="h2 article-title">Contact</h2>
      </header>

      <section className="contact-form">
        <h3 className="h3 form-title">Contact Form</h3>

        <form onSubmit={handleSubmit} className="form" data-form>
          <div className="input-wrapper">
            <input
              type="text"
              name="fullname"
              className="form-input"
              placeholder="Full name"
              required
              data-form-input
            />

            <input
              type="email"
              name="email"
              className="form-input"
              placeholder="Email address"
              required
              data-form-input
            />
          </div>

          <textarea
            name="message"
            className="form-input"
            placeholder="Your Message"
            required
            data-form-input
          ></textarea>

          <button
            className="form-btn"
            type="submit"
            disabled={isSending}
            data-form-btn
          >
            <FontAwesomeIcon icon={faPaperPlane} />
            <span>{isSending ? "Sending..." : "Send Message"}</span>
          </button>
        </form>

        {/* Toast Notification */}
        {showToast && <div className="toast-notification">{toastMessage}</div>}
      </section>

      <style jsx>{`
        .toast-notification {
          position: fixed;
          bottom: 20px;
          right: 20px;
          background-color: #4caf50;
          color: white;
          padding: 10px 20px;
          border-radius: 5px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
          transition: opacity 0.5s ease;
          z-index: 1000;
        }
      `}</style>
    </article>
  );
};

export default Contact;
